import { AppError } from './app-error';

export const API_TIMEOUT_ERROR_CODE = 'API_REQUEST_TIMEOUT';

export const createTimeoutError = (timeoutMs, url) =>
    new AppError({
        kind: AppError.KIND.TIMEOUT,
        message: `API request timed out after ${timeoutMs}ms`,
        url,
        payload: { timeoutMs },
    });

export const isTimeoutError = (error) =>
    Boolean(error?.kind === AppError.KIND.TIMEOUT || error?.code === API_TIMEOUT_ERROR_CODE);

export const appErrorFor = (input, ctx) => AppError.from(input, ctx);

export const handleError = (input, ctx) => {
    throw AppError.from(input, ctx);
};
